module.exports={account_link_complete_message:"Vinculação de conta Nexon concluída."};